import {FETCH_ALL_SPECIES, FETCH_SPECIES_FILTERS} from "@/store/actions.type";
import {
	SET_ALL_SPECIES,
	SET_FILTER_APPLICATION,
	SET_FILTER_AVAILABILITY,
	SET_FILTER_COLOR,
	SET_FILTER_FSC,
	SET_FILTER_OCCURRENCE,
	SET_FILTER_PEFC,
	SET_FILTER_PRICEGROUP,
	SET_GALLERY_SORTING,
	SET_GALLERY_SORTING_DIRECTION,
	SET_GALLERY_VIEW,
	SET_LOADING,
	SET_SPECIES_FILTER_LIST
} from "@/store/mutations.type";
import {SpeciesService} from "@/common/api";
import {GALLERY_SORTING, GALLERY_SORTING_DIRECTION, GALLERY_VIEW, INITIAL_SPECIES_SEARCH_PARAMS} from "@/common/constants";

const state = {
	speciesList: [],
	species: [],
	sword: '',
	speciesCount: 0,
	colorList: [],
	applicationList: [],
	occurrenceList: [],
	searchParams: {...INITIAL_SPECIES_SEARCH_PARAMS},
	galleryView: GALLERY_VIEW.TEASER,
	gallerySorting: GALLERY_SORTING.NAME,
	gallerySortingDirection: GALLERY_SORTING_DIRECTION.ASCENDING,
	loadingFilters: false
};

export const getters = {
	speciesList: state => state.speciesList,
	galleryView: state => state.galleryView,
	gallerySorting: state => state.gallerySorting,
	gallerySortingDirection: state => state.gallerySortingDirection,
	speciesColorList: state => state.colorList,
	speciesApplicationList: state => state.applicationList,
	speciesOccurenceList: state => state.occurrenceList,
	loadingSpeciesFilters: state => state.loadingFilters,
	filteredSpeciesList: state => {
		const filteredSpeciesList = state.speciesList.filter(species => {
			return (
				(!state.searchParams.color || species.color.uid === state.searchParams.color) &&
				(!state.searchParams.application || species.application.some(application => {
					return application.uid === state.searchParams.application
				})) &&
				(!state.searchParams.occurrence || species.occurrence.some(occurrence => {
					return occurrence.uid === state.searchParams.occurrence
				})) &&
				(!state.searchParams.fsc || species.fsc) &&
				(!state.searchParams.pefc || species.pefc) &&
				state.searchParams.availability.includes(species.availability) &&
				state.searchParams.pricegroup.includes(species.pricegroup)
			)
		});

		return state.gallerySortingDirection ? filteredSpeciesList.reverse() : filteredSpeciesList;
	}
};

const actions = {
	async [FETCH_ALL_SPECIES]({commit}, params) {
		if (this.state.species.speciesList.length === 0) {
			commit(SET_LOADING, true);
			return SpeciesService.get()
				.then(({data}) => {
					commit(SET_ALL_SPECIES, data.objects);
					commit(SET_LOADING, false);
				})
				.catch(error => {
					throw new Error(error);
				})
		}
	},
	async [FETCH_SPECIES_FILTERS]({commit}) {
		this.loadingFilters = true;
		return SpeciesService.getSpeciesFilters()
			.then(({data}) => {
				commit(SET_SPECIES_FILTER_LIST, data.objects);
				this.loadingFilters = true;
			})
			.catch(error => {
				this.loadingFilters = true;
				throw new Error(error);
			})
	}
};

const mutations = {
	[SET_ALL_SPECIES](state, species) {
		state.speciesList = species;
	},
	[SET_SPECIES_FILTER_LIST](state, filters) {
		state.colorList = filters.colors;
		state.applicationList = filters.applications;
		state.occurrenceList = filters.occurrences;
	},
	[SET_FILTER_COLOR](state, color) {
		state.searchParams.color = parseInt(color);
	},
	[SET_FILTER_APPLICATION](state, application) {
		state.searchParams.application = parseInt(application);
	},
	[SET_FILTER_AVAILABILITY](state, availability) {
		state.searchParams.availability = availability;
	},
	[SET_FILTER_PRICEGROUP](state, pricegroup) {
		state.searchParams.pricegroup = pricegroup;
	},
	[SET_FILTER_OCCURRENCE](state, occurrence) {
		state.searchParams.occurrence = parseInt(occurrence);
	},
	[SET_FILTER_FSC](state, fsc) {
		state.searchParams.fsc = fsc;
	},
	[SET_FILTER_PEFC](state, pefc) {
		state.searchParams.pefc = pefc;
	},
	[SET_GALLERY_VIEW](state, type) {
		state.galleryView = type;
	},
	[SET_GALLERY_SORTING](state, sorting) {
		state.gallerySorting = sorting;
	},
	[SET_GALLERY_SORTING_DIRECTION](state, direction) {
		state.gallerySortingDirection = direction;
	}
};

export default {
	state,
	getters,
	actions,
	mutations
};